// import { Button } from '@material-ui/core';
import { Container } from '@material-ui/core';
import React, { useState } from 'react';
import SampleRecorder from './spm/recorder/SampleRecorder';
import * as ebml from 'ts-ebml';

const EbmlParser = () => {
  const [metadata, setMetadata] = useState(null);
  const [brokenWithoutMetadata, setBrokenWithoutMetadata] = useState(null);
  const [refined, setRefined] = useState(null);
  const metadataRef = React.useRef(null);

  const handleUploadSample = async (event) => {
    if (metadata) {
      URL.revokeObjectURL(metadata);
      setMetadata(null);
    }
    const file = event.target.files[0];
    if (!file) {
      console.error('No file selected');
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const arrayBuffer = e.target.result;
      const blob = new Blob([arrayBuffer], { type: 'video/webm' });
      const sr = new SampleRecorder({});
      try {
        const metadata = await sr.getMetaDataFromChunk(blob);
        console.log("Metadata:", metadata);
        metadataRef.current = metadata;
        const metadataBlob = new Blob([metadata], { type: 'video/webm' });
        const url = URL.createObjectURL(metadataBlob);
        console.log("URL:", url);
        setMetadata(url);
      }
      catch (error) {
        console.error("Error getting metadata:", error);
      }

    };
    reader.readAsArrayBuffer(file);
  }
  const handleUploadBroken = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error('No file selected');
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const arrayBuffer = e.target.result;
      try {
        const decoder = new ebml.Decoder();
        const reader = new ebml.Reader();
        const elms = decoder.decode(arrayBuffer);
        elms.forEach((elm) => { 
          console.log("elm", elm);
          reader.read(elm); 
        });
        console.log("got data", reader.metadatas, elms, reader);
        //remove metadata
        const bufferWithoutMetadata = arrayBuffer.slice(reader.metadataSize);
        const blob = new Blob([bufferWithoutMetadata], { type: 'video/webm' });
        const url = URL.createObjectURL(blob);
        setBrokenWithoutMetadata(url);
        if (metadataRef.current) {
          const refinedBlob = new Blob([metadataRef.current, bufferWithoutMetadata], { type: 'video/webm' });
          const refinedUrl = URL.createObjectURL(refinedBlob);
          setRefined(refinedUrl);
        }
      }
      catch (error) {
        console.error("Error getting metadata:", error);
      }
    };
    reader.readAsArrayBuffer(file);
  }

  return (
    <Container>
      <h2>Upload Sample</h2>
      <input
        id="select-sample"
        type="file"
        accept=".webm"
        onChange={handleUploadSample}
      />
      {/* <label htmlFor="select-sample">
        <Button color="default" component="span" variant="contained">Upload Image</Button>
      </label> */}
      {metadata && <a href={metadata} download="metadata.webm">Download Metadata</a>}
      <h2>Upload Broken File</h2>
      <input
        id="select-broken"
        type="file"
        accept=".webm"
        onChange={handleUploadBroken}
      />
      {/* <label htmlFor="select-broken">
        <Button color="default" component="span" variant="contained">Upload Image</Button>
      </label> */}
      {brokenWithoutMetadata && <a href={brokenWithoutMetadata} download="broken.webm">Download Broken</a>}
      {refined && <a href={refined} download="refined.webm">Download Refined</a>}
    </Container>
  );
}

export default EbmlParser;